import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotificationService } from '@services/notification.service';
import { UsersService } from '../../services/users.service';
import { WebErrorService } from '@services/webError.service';
import { ItemService } from '@services/item.service';
import { customValidationService } from 'src/app/shared/custom.validator';
@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.scss']
})
export class UserCreateComponent implements OnInit {

  userDetailsForm: FormGroup;
  duplicateDataFlag = false;
  errorMessage: string;
  action = 'createUser';
  apiData: any;
  statusList: any;
  inValidEmail: boolean = false;
  inValidPhone: boolean = false;
  constructor(
    private usersService: UsersService,
    private router: Router,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<UserCreateComponent>,
    public itemService: ItemService
  ) { }

  ngOnInit(): void {
    this.usersService.getStatusList().subscribe((statusList) => { this.statusList = statusList.data;})
    this.userDetailsForm = new FormGroup({
      'firstName': new FormControl(null,
        [Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/)
        ]),
      'lastName': new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/)
      ]),
      'phone': new FormControl(null, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(24),
        Validators.pattern(/^(?:\+?(\d{0,3}))?[- \(]*(\d{1,9})[-. \/)]*(\d{1,9})[-. \/]*(\d{1,9})*[-. \/]*(\d{1,9})(?: *x(\d))?$/)
      ]),
      'emailId': new FormControl(null,
        [Validators.required,
        Validators.minLength(7),
        Validators.maxLength(124),
        // Validators.pattern(/^[a-zA-Z0-9]+([.]?[_]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)*\.[A-Za-z]{1,3}$/)
        // Validators.pattern(/^[a-zA-Z0-9]+([.]?[_]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)\.[A-Za-z]{2,3}$/)
        // Validators.pattern(/^[a-zA-Z0-9]+([.]?[_]?[a-zA-Z0-9])*@[a-zA-Z0-9]+[A-Za-z]{2,6}$/)
        Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}')

        ]),
      'password': new FormControl(null,
        [Validators.required,
        Validators.maxLength(20),
        // Validators.minLength(12),
        // Validators.pattern(/^(?!.*(.)\1)(?!.*?123|321|234|432|345|543|456|654|567|765|678|876|789|987|890|098)(?=.{12,}).*$/),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*^])[a-zA-Z0-9!@#$%&*^]{12,}$'),
        this.validatePassword.bind(this),

        // Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()-_=+/\|";:<>,.`~])[A-Za-z\d@$!%*?&#^()-_=+/\|";:<>,.`~]{6,20}$/)
        ]),
      'status': new FormControl('true', [Validators.required]),
      'speciality': new FormControl(null,
        [Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[a-z\d\-_\s]+$/i)
        // Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]),
        'center': new FormControl(null,
        [Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[a-z\d\-_\s]+$/i)
        ]),
    });
  }

  get f() {
    return this.userDetailsForm?.controls;
  }

  onClickOutside(event: any, name) {
    if(event && name == 'email') {
      this.inValidEmail = true; this.inValidPhone = false;
    } else {
      this.inValidEmail = false;
      console.log(this.userDetailsForm.controls)
    }

    if(event && name == 'phone') {
      this.inValidEmail = false; this.inValidPhone = true;
    } else {
      this.inValidPhone = false;
    }
  }

  validatePassword(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.value;
    let email = this.userDetailsForm?.get('emailId').value;
    if(password === email){
      return { passwordSameAsUsernameOrEmail: true };
    }
    return null;
  }
  // validatePassword(control: AbstractControl): { [key: string]: boolean } | null {
  //   const password = control.value;
  //   const regData = JSON.parse(sessionStorage.getItem('currentUser'))
  //   if (password.includes(regData.emailId)){
  //     return { passwordSameAsUsernameOrEmail: true };
  //   }
  //   return null;
  // }

  saveUserDetails() {

    this.apiData = {
      // collectioId: this.collectionId,
      firstName: this.userDetailsForm.value.firstName.trim(),
      lastName: this.userDetailsForm.value.lastName.trim(),
      phone: this.userDetailsForm.value.phone,
      emailId: this.userDetailsForm.value.emailId.trim(),
      active: this.userDetailsForm.value.status,
      password: this.userDetailsForm.value.password,
      roles: [],
      speciality: this.userDetailsForm.value.speciality,
      center: this.userDetailsForm.value.center,
    }




    this.usersService.createNewUser(this.apiData).subscribe(resData => {
      this.notificationService.success(resData?.message);
      this.dialogRef.close();
      this.usersService.getusersLanding()?.subscribe(itemListRes => {
        // this.dialogRef.close();
        this.usersService.newUserList(itemListRes);
        // this.dialogRef.close();
        // this.notificationService.success(itemListRes?.message);
        // this.router.navigate(["/users"]);

      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });

      if (resData.useruuid) {
        // this.router.navigate(["/users", data.testId]);
      }
    },
      error => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        if (error?.status == 409) {
          this.userDetailsForm.patchValue({ "emailId": null });
        }
      });
  }


  // sdfs

  onTestNameControlFocus(): void {
    this.duplicateDataFlag = false;
  }

  navigateToUsersLanding() {
    this.router.navigate(["/users"]);
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === ' ' && !this.userDetailsForm.value.phone.length)
      event.preventDefault();
  }
}
